import OTelInput from "./OTelInput";

export default OTelInput;